module.exports = __webpack_public_path__ + "email-analytics-grab-95d4cdee2b69fb1a3384b59b1133a3d3.png";